import { connect } from 'react-redux';
import { IState } from '../../../../store/types';
import { getAudioById } from '../../../../store/models/selectors';
import { getCurrentAudioId } from '../../../../store/current-video/selectors';
import { DateUtil } from '../../../../../common/utils/dateUtil';
import { isProgressLogActive } from '../../../../../common/utils/conferenceProgress';
import { AudioPage } from '../components/AudioPage';
import { IAudioPageEvents, IAudioPageFields } from '../components/types';
import { AudioPageEvents } from './events';

const NO_LOG: string[] = []; // stable, so connect doesn't re-render on every store change

const mapStateToProps = (
  state: IState
): IAudioPageFields => {
  const audioId = getCurrentAudioId(state);
  const audio = audioId ? getAudioById(state, audioId) : null;
  const date = audio?.createdAt ? DateUtil.formatDateTime(new Date(audio.createdAt)) : '';
  const progressLog = audio?.progressLog || NO_LOG;
  return {
    title: audio?.title || date,
    date,
    audioId: audioId || undefined,
    canEditSettings: !!audio?.roomName,
    progressLog,
    isProcessing: isProgressLogActive(progressLog),
    progressStartedAt: audio?.progressStartedAt,
    progressStepStartedAt: audio?.progressStepStartedAt,
    progressUpdatedAt: audio?.progressUpdatedAt,
  };
}

const mapDispatchToProps = (
  dispatch: any
): IAudioPageEvents => ({
  onChangeRoute: (groupId, audioId) => dispatch(AudioPageEvents.onChangeRoute(groupId, audioId)),
  onChangeTab: (groupId, audioId, tab) => dispatch(AudioPageEvents.onChangeTab(groupId, audioId, tab)),
  onReprocess: (force, steps) => dispatch(AudioPageEvents.onReprocess(force, steps)),
  onCancel: () => dispatch(AudioPageEvents.onCancel()),
  onCloseSettings: () => dispatch(AudioPageEvents.onCloseSettings()),
  onPlayTimestamp: (time) => dispatch(AudioPageEvents.onPlayTimestamp(time)),
  onPlayCaption: (index) => dispatch(AudioPageEvents.onPlayCaption(index)),
  onPause: () => dispatch(AudioPageEvents.onPause()),
});

export const AudioPageHOC = connect(
  mapStateToProps,
  mapDispatchToProps
)(AudioPage);

AudioPageHOC.displayName = 'AudioPageHOC';
